export default __webpack_public_path__ + "static/media/katie_buerk.2d3b9257.gif";